import { render, staticRenderFns } from "./AffiliateCreditShareIndex.vue?vue&type=template&id=632ee55e&"
import script from "./AffiliateCreditShareIndex.vue?vue&type=script&lang=js&"
export * from "./AffiliateCreditShareIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports